import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TYPE from "../../../../constant/TYPE";
import { loadQuestionAction } from "../../../../redux/answeringQuestions/answeringQuestions";

const OXPopupHider = ( props ) => {

  const dispatch = useDispatch();
  const loadQuestion = payload => { dispatch( loadQuestionAction( payload ) ) };

  useEffect( () => {
    const timer = setTimeout( hideOXPopup, 1000 );
    return () => {
      clearTimeout( timer );
    };
  }, [] );

  const hideOXPopup = () => {
    console.log("***** 다음문제")
    loadQuestion( { progressCode : TYPE.ANSWERING_QUESTIONS_PROGRESS.CONTINUE } );
  };

  return props.children || null;

};

export default OXPopupHider;
